















import {
  Component,
  ComponentStyle,
  ComponentStyleDefinition,
  FlowStepType,
  Prop,
  Vue
} from "@zoovu/runner-browser-api";

@Component({})
export default class Breadcrumbs extends Vue {
  @Prop()
  flowSteps!: FlowStepType[];

  @ComponentStyle()
  componentStyle!: ComponentStyleDefinition;

  getBreadcrumbsNames() {
    const breadcrumbsNames = [];
    this.flowSteps.map(flowStep => {
      const question = flowStep.questions[0];
      if (question.questionType === "NUMERIC") {
        const breadcrumbSliderName =
          (question.value ? question.value : question.defaultValue) + question.unit;
        breadcrumbsNames.push(breadcrumbSliderName);
      } else {
        question.answers.map(answer => {
          if (answer.selected) {
            const breadcrumbName =
              (answer.parameters.hasOwnProperty("breadcrumbDefault") &&
                answer.parameters.breadcrumbDefault) ||
              !answer.parameters.hasOwnProperty("breadcrumbDefault")
                ? answer.answerText
                : answer.parameters.hasOwnProperty("breadcrumbDefault") &&
                  !answer.parameters.breadcrumbDefault
                ? ""
                : answer.parameters.breadcrumbName;
            breadcrumbsNames.push(breadcrumbName);
          }
        });
      }
    });
    return breadcrumbsNames;
  }
}
